import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form, InputForm, Validation } from "../../components/Form";
import { Autocomplete, AutocompleteMulti } from "../../components/Autocomplete";
import { BasePaper, Row } from "../../components/Base";
import Button from "../../components/Button";
import { StyledSwitch } from "../../components/Base";
import { getProcessStepById, createProcessStep, updateProcessStep } from "../../api/process-step";
import processStepList from "../../services/typeProcessStep.json";
import { getActivitiesTraining } from "../../api/activities-training";

const EditProcessStep = ({ match, history }) => {
  const { t } = useTranslation();
  const { processStepId } = match.params;
  const isAdd = !processStepId;
  const [processStep, setProcessStepRes] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [selectedProcessStepType, setProcessStepTypes] = useState();
  const [ActivitiesTrainings, setActivitiesTrainings] = useState([]);
  const [selectedActivitiesTrainings, setSelectedActivitiesTrainings] = useState([]);

  const [selectedStatus, setStatus] = useState("active");

  useEffect(() => {
    (async () => {
      const activitiesTrainings = await getActivitiesTraining();
      setActivitiesTrainings(activitiesTrainings);
      if (processStepId) {
        const processStepRes = await getProcessStepById(processStepId);
        setProcessStepRes(processStepRes);
        const itemProcessStep = processStepList.find((c) => c.code === processStepRes.type);
        setProcessStepTypes(itemProcessStep);
        setStatus(processStepRes.status);
        setSelectedActivitiesTrainings(processStepRes.activitiesTrainings);
      }
      setLoaded(true);
    })();
  }, [processStepId]);

  const goBack = () => history.goBack();
  const onSubmit = async (values) => {
    if (selectedProcessStepType) {
      values.type = selectedProcessStepType?.code;
    } else {
      values.type = "";
    }
    values.status = selectedStatus;

    const activitiesTrainingsIds = selectedActivitiesTrainings.map((c) => c.id);

    let result;
    if (isAdd) {
      result = await createProcessStep(values, activitiesTrainingsIds);
    } else {
      result = await updateProcessStep(processStepId, values, activitiesTrainingsIds);
    }
    if (result.ok) {
      history.push("/process-step");
    }
  };

  const title = isAdd ? t("process_step.add_title") : t("process_step.edit_title");

  return (
    <>
      <Typography variant="h4">
        <Button icon={<ArrowBackIcon />} onClick={goBack} />
        {title}
      </Typography>
      {loaded ? (
        <BasePaper>
          <Form
            defaultValues={{
              name: processStep?.name,
              type: processStep?.type,
            }}
            validation={{
              name: Validation.required,
            }}
            onSubmit={onSubmit}
          >
            <Row>
              <InputForm name="name" label={t("process_step.name_required")} />
            </Row>
            <Row>
              <Autocomplete
                label={t("process_step.type")}
                options={processStepList}
                value={selectedProcessStepType}
                onChange={(items) => {
                  setProcessStepTypes(items);
                }}
                getOptionLabel={(item) => `${item.name}`}
              />
            </Row>

            <Row>
              <AutocompleteMulti
                label={t("process_step.activities_trainings_list")}
                options={ActivitiesTrainings}
                value={selectedActivitiesTrainings}
                onChange={(items) => {
                  setSelectedActivitiesTrainings(items);
                }}
              />
            </Row>

            <Row>
              {t("status")}{" "}
              <StyledSwitch
                title={t("process_step.change_status")}
                checked={selectedStatus === "active"}
                onChange={() => setStatus(selectedStatus === "active" ? "passive" : "active")}
              />
            </Row>

            <Row>
              <Button type="submit">{t("save")}</Button>
              <Button onClick={goBack}>{t("cancel")}</Button>
            </Row>
          </Form>
        </BasePaper>
      ) : null}
    </>
  );
};

export default EditProcessStep;
